import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

const SingleItem = ({ data }) => {
  const [livePrice, setLivePrice] = useState([]);
  const [loading, setLoading] = useState(true);
  // const { popular_market_id: HotData } = data;

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData();
    }, 1000);
    return () => clearInterval(interval);
  }, [livePrice]);

  const fetchData = async () => {
    if (data !== null) {
      if (data?.market === "Crypto" && data?.crypto_market_id) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/crypto/tickers/X:${data?.crypto_market_id?.Symbol}${data?.crypto_market_id?.currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if ((data?.market === "Forex" && data?.forex_market_id)) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${data?.forex_market_id?.base_currency}${data?.forex_market_id?.quote_currency}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if ((data?.market === "Metal" && data?.metal_market_id)) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/global/markets/forex/tickers/C:${data?.metal_market_id?.symbol}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
      if (data?.market === "Stock" && data?.stock_market_id) {
        fetch(
          `https://api.massive.com/v2/snapshot/locale/us/markets/stocks/tickers/${data?.stock_market_id?.symbol}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}`,
          {
            method: "GET",
          }
        )
          .then((res) => res.json())
          .then((data) => {
            if (data?.ticker) {
              setLivePrice(data?.ticker);
            }
            if (loading) {
              setLoading(false);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
      }
    }
  };
  if (loading || data === null) {
    return;
  }
  return (
    <>
      <div className="markets-coin">
        <Link to="#">
          <div className="markets-coin-left">
            <div className="markets-coin-image">
              <LazyLoadImage
                effect="blur"
                alt="img"
                src={`https://api.wlfmobile.com/${data?.crypto_market_id?.image || data?.forex_market_id?.image || data?.metal_market_id?.image || data?.stock_market_id?.image}`}
                className="hot-coin-img"
              />
            </div>
            <div className="markets-coin-name">
              <h4>{data?.crypto_market_id?.Name || data?.forex_market_id?.name || data?.metal_market_id?.name || data?.stock_market_id?.name}</h4>
              <h5>
                {(data?.crypto_market_id && `${data?.crypto_market_id?.Symbol}${data?.crypto_market_id?.currency}`) ||
                  (data?.forex_market_id &&
                    `${data.forex_market_id.base_currency}/${data.forex_market_id.quote_currency}`) ||
                  data?.metal_market_id?.symbol ||
                  data?.stock_market_id?.symbol}
              </h5>
            </div>
          </div>
          <div className="markets-coin-right">
            <div className="markets-coin-price">
              <p>
                {livePrice?.lastQuote?.a || livePrice?.lastTrade?.p ? "$" : ""}

                {data?.market === "Forex" &&
                  !isNaN(livePrice?.lastQuote?.a) &&
                  parseFloat(livePrice?.lastQuote?.a) +
                  parseFloat(data?.forex_market_id?.price)}

                {data?.market === "Metal" &&
                  !isNaN(livePrice?.lastQuote?.a) &&
                  parseFloat(livePrice?.lastQuote?.a) +
                  parseFloat(data?.metal_market_id?.price)}

                {data?.market === "Crypto" &&
                  !isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                  parseFloat(data?.crypto_market_id?.price)}

                {data?.market === "Stock" &&
                  !isNaN(livePrice?.lastTrade?.p) &&
                  parseFloat(livePrice?.lastTrade?.p) +
                  parseFloat(data?.stock_market_id?.price)}

                {livePrice?.lastQuote?.a === 0 ? (
                  <div className="market-closed">closed</div>
                ) : (
                  !livePrice?.lastQuote?.a &&
                  !livePrice?.lastTrade?.p && (
                    <div className="market-closed">closed</div>
                  )
                )}
              </p>
            </div>
            <div className="markets-coin-percentage">
              {livePrice?.todaysChangePerc && (
                <>
                  <p
                    className={`${livePrice?.todaysChangePerc >= 0
                      ? "up-price"
                      : "dwon-price"
                      }`}
                  >
                    <i class="fa-solid fa-arrow-right"></i>
                    {parseFloat(livePrice?.todaysChangePerc).toFixed(2)}%
                  </p>
                </>
              )}
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default SingleItem;
